'use client';
import { routes } from '~constants/routes';
import { usePathname } from '~i18n/navigation';

export const useSluggedPathname = () => {
	let pathname = usePathname();
	let sluggedPathname = pathname;

	const dialogsMatch = pathname.match(/^\/chats\/[^\/]+$/);
	if (dialogsMatch) {
		pathname = routes.chats.home;
		sluggedPathname = routes.chats.dialog('{botId}');
	}

	return [pathname, sluggedPathname];
};
